// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__UtM0f","label":"Labeled_label__d6R-6","divider":"Labeled_divider__1mbS5"};